// extracted by mini-css-extract-plugin
module.exports = {"TextWrapper":"styles_TextWrapper__hnpgp","Text":"styles_Text__HnaHX"};